export const FEATURE_NAME = '@zerops/zerops/feature/victoria-logs-overlay';
